let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4QCvQ")).then(() => parcelRequire('2KBQE'));